import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { FC, useState } from 'react';
import styles from './FavoriteButton.module.scss';

interface FavoriteButtonProps {
  onClickFavorites: () => void;
  isFavorite: boolean;
  fontSize?: string;
}

const defaultProps = { fontSize: '25px' };

const FavoriteButton: FC<FavoriteButtonProps> = ({ onClickFavorites, isFavorite, fontSize }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <Tooltip
      title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      open={showTooltip}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <IconButton
        size="small"
        onClick={() => {
          setShowTooltip(false);
          onClickFavorites();
        }}
        aria-label="Add to favorites"
      >
        <span style={{ fontSize }}>
          {isFavorite ? (
            <span className={styles.favoriteButton__icon__is_favorite}>
              <Icon iconId="favorites" />
            </span>
          ) : (
            <Icon iconId="favorites-outlined" />
          )}
        </span>
      </IconButton>
    </Tooltip>
  );
};

FavoriteButton.defaultProps = defaultProps;

export default FavoriteButton;
